import React, { useEffect, useState } from "react";
import {
  Table,
  Card,
  Tooltip,
  Modal,
  Row,
  Col,
  Typography,
  Button,
  Descriptions,
  Form,
  Input,
  Select,
  notification,
  Popconfirm,
  message,
} from "antd";
import { postReq } from "../api";
import { toastNotification } from "../utils/toasthelper";
import useUserDetails from "../utils/useUserDetails";
import moment from "moment";
import { useHistory } from "react-router-dom";
const { Title } = Typography;
const { Option } = Select;

const JobCompany = () => {
  const [data, setData] = useState([]);
  const [isSearch, setIsSearch] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const columns = [
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          {/* {(userData?.userRole == "company" ||
            userData?.permissions?.includes("client_details")) && ( */}
          <Tooltip title="View Detail">
            <svg
              width="24"
              height="16"
              viewBox="0 0 30 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => handleClick(record)}
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.2818 0.0159601C7.45391 0.319947 1.70525 4.93397 0.109432 11.136C0.03645 11.4196 0 11.7099 0 12C0 12.2901 0.0364637 12.5804 0.109432 12.864C1.68348 18.9815 7.29798 23.554 14.0032 23.9692C14.3329 23.9896 14.6654 24 15 24C22.14 24 28.2391 19.2824 29.8906 12.864C29.9636 12.5804 30 12.2901 30 12C30 11.7099 29.9636 11.4196 29.8906 11.136C28.2391 4.71767 22.14 0 15 0C14.7593 0 14.5199 0.00536006 14.2818 0.0159601ZM21.8182 12C21.8182 15.6819 18.7657 18.6667 15 18.6667C11.2345 18.6667 8.18186 15.6819 8.18186 12C8.18186 8.31811 11.2345 5.33333 15 5.33333C18.7657 5.33333 21.8182 8.31811 21.8182 12ZM15 16C17.2594 16 19.0909 14.2092 19.0909 12C19.0909 9.7908 17.2594 8 15 8C12.7407 8 10.9091 9.7908 10.9091 12C10.9091 14.2092 12.7407 16 15 16Z"
                fill="#13487D"
              />
            </svg>
          </Tooltip>
          {/* )} */}
        </div>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      //   render: (text) => <p>{text}</p>,
    },
    {
      title: "ICP Counts",
      dataIndex: "icpJobsCount",
      key: "icpJobsCount",
      //   render: (text) => <p>{text}</p>,
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (text) => <p>{moment(text).format("DD/MM/YYYY HH:mm")}</p>,
    },
    // {
    //   title: "Vendor Email",
    //   dataIndex: "clientEmail",
    //   key: "clientEmail",
    //   render: (text) => (
    //     <a
    //       //   href={`mailto:${text}`}
    //       href={`https://outlook.office.com/mail/deeplink/compose?to=${text}`}
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       style={{ color: "#3699FF", textDecoration: "underline" }}
    //     >
    //       {text}
    //     </a>
    //   ),
    // },
    // {
    //   title: "SPOC Email",
    //   dataIndex: "spocEmail",
    //   key: "spocEmail",
    //   render: (text) => (
    //     <a
    //       //   href={`mailto:${text}`}
    //       href={`https://outlook.office.com/mail/deeplink/compose?to=${text}`}
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       style={{ color: "#3699FF", textDecoration: "underline" }}
    //     >
    //       {text}
    //     </a>
    //   ),
    // },
    // {
    //   title: "SPOC Mobile",
    //   dataIndex: "spocPhone",
    //   key: "vendorCompanyWebsiteUrl",
    // },
    // {
    //   title: "SPOC Person",
    //   key: "vendorCompanyWebsiteUrl",
    //   render: (record) => `${record.spocName} (${record.spocDesignation})`,
    // },
  ];
  const [form] = Form.useForm();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [tableParams, setTableParams] = useState({
    page: 1,
    limit: 10,
    search: "",
  });

  const userData = useUserDetails();
  const userRole = localStorage.getItem("userRole");

  const handleClick = (record) => {
    history.push({
      pathname: `/company/jobcompanyView`,
      state: {
        record,
      },
    });
    // setModalData(record);
    // setVisible(true);
  };
  const fetchData = async () => {
    setLoading(true);
    try {
      let results;
      results = await postReq("common/list_job_company", tableParams);
      if (results.status === 1) {
        setData(results?.data);
        setTotal(results.meta.total);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      toastNotification("error", error.message);
      setLoading(false);
    }
  };
  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchData();
    }, 300);

    return () => clearTimeout(timeout);
  }, [tableParams.search, tableParams.page, tableParams.limit]);

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams((prev) => ({
      ...prev,
      page: pagination.current,
      limit: pagination.pageSize,
    }));

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  const handleOnChange = (e) => {
    setTableParams((prev) => ({ ...prev, search: e.target.value }));
  };

  const handleMultiDownload = async () => {
    try {
      const res = await postReq(
        "/common/download_jobposting",
        { jobIds: selectedRowKeys },
        { responseType: "blob" }, // IMPORTANT
      );

      // Create download
      const blob = new Blob([res], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Selected_Companies.xlsx";
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      message.success("Selected records downloaded successfully ✅");
      setSelectedRowKeys([]);
    } catch (error) {
      console.error(error);
      message.error("Download failed ❌");
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedKeys) => {
      setSelectedRowKeys(newSelectedKeys);
    },
  };

  return (
    <>
      <Card
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px",
              borderRadius: "20px 20px 0px 0px",
              margin: "0px -24px",
            }}
          >
            <div>
              <Title
                level={4}
                style={{
                  marginBottom: 0,
                  fontSize: "20px",
                  fontWeight: "800",
                  color: "#13487D",
                }}
              >
                Acounts
              </Title>
            </div>

            <div style={{ display: "inline-flex", gap: "8px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#F4F4F4",
                  borderRadius: "10px",
                  // padding: "10px 16px",
                  width: "300px",
                  boxShadow: "0px 1px 5px rgba(0,0,0,0.1)",
                }}
              >
                <Input
                  placeholder="Search By Client Name"
                  bordered={false}
                  onChange={handleOnChange}
                  style={{
                    fontSize: "16px",
                    color: "#6F6F6F",
                    border: "none",
                  }}
                />
                <svg
                  width="44"
                  height="44"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => setIsSearch(!isSearch)}
                >
                  <rect width="64" height="64" rx="18" fill="#F4F4F4" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M35.2267 37.1801L40.6511 42.5978C41.1882 43.1342 42.0603 43.134 42.5974 42.5975C43.1343 42.0607 43.1342 41.1893 42.5971 40.6527L37.1763 35.2389C38.2668 33.757 38.9114 31.9269 38.9114 29.9476C38.9114 25.0092 34.8985 21 29.9557 21C25.0129 21 21 25.0092 21 29.9476C21 34.8859 25.0129 38.8951 29.9557 38.8951C31.9255 38.8951 33.7474 38.2586 35.2267 37.1801ZM29.9557 23.7501C33.3793 23.7501 36.159 26.5271 36.159 29.9476C36.159 33.3681 33.3793 36.1452 29.9557 36.1452C26.5321 36.1452 23.7526 33.3681 23.7526 29.9476C23.7526 26.5271 26.5321 23.7501 29.9557 23.7501Z"
                    fill="#13487D"
                  />
                </svg>
              </div>
              {/* )} */}
              {/* {(userData?.userRole == "company" ||
                userData?.permissions?.includes("add_client")) && (
                <svg
                  width="44"
                  height="44"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => setShowModal(true)}
                  style={{ cursor: "pointer" }}
                >
                  <rect width="64" height="64" rx="18" fill="#F4F4F4" />
                  <path
                    d="M32 22V42"
                    stroke="#13487D"
                    stroke-width="2.7"
                    stroke-linecap="round"
                  />
                  <path
                    d="M42 32L22 32"
                    stroke="#13487D"
                    stroke-width="2.7"
                    stroke-linecap="round"
                  />
                </svg>
              )} */}
            </div>
          </div>
        }
        style={{
          paddingLeft: "16px",
          color: "#13487D",
          borderRadius: "18px",
          maxWidth: "100%",
          overflow: "hidden",
        }}
        bordered={false}
      >
        <Popconfirm
          title="Are you sure you want to Download selected records?"
          onConfirm={handleMultiDownload}
        >
          <Button
            info
            disabled={selectedRowKeys.length === 0}
            style={{ marginBottom: "10px" }}
          >
            Download Selected ({selectedRowKeys.length})
          </Button>
        </Popconfirm>
        <Table
          rowKey="_id"
          rowSelection={rowSelection}
          columns={columns}
          dataSource={data}
          pagination={{
            current: tableParams.page,
            pageSize: tableParams.limit,
            total,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 30],
            // position: ["bottomCenter"],
            itemRender: (current, type, originalElement) => {
              if (type === "prev") {
                return <a>Prev</a>;
              }
              if (type === "next") {
                return <a>Next</a>;
              }
              return originalElement;
            },
            showTotal: (total, range) => (
              <span style={{ color: "#6b7280" }}>
                Showing {range[0]}–{range[1]} of {total}
              </span>
            ),
          }}
          loading={loading}
          scroll={{ x: "max-content" }}
          onChange={handleTableChange}
        />
      </Card>
    </>
  );
};

export default JobCompany;
